import { AssetStore } from "../assets/AssetsStore"


export const C2MD_ANDROID_APP_LINK = "https://play.google.com/store/apps/details?id=com.neevlabs.connect2mydoctorpatient&hl=en"
export const C2MD_IOS_APP_LINK = "https://apps.apple.com/au/app/connect2mydoctor-for-patients/id1490627746"

export const USER_TYPE = "c2mdUserUserType"
export const USER_DATA = "userData"
export const ADMIN_USER = "C2MDAdmin"
export const USER_TOKEN = "c2mdUserToken"
export const DOCTOR = "Doctor"
export const INTERBRANCH_COORDINATOR = "Coordinator"
export const PATIENT = "Patient"
export const CLINIC_ADMIN= "ClinicAdmin";

export const INTERBRANCH_CLEAR_CONTEXT = "Clear"
export const INTERBRANCH_SAVE_CONTEXT = "Save"

export const INTERBRANCH_PAGE_VITALS = "patientvitals"
export const INTERBRANCH_PAGE_LIFESTYLE = "lifestyle"
export const INTERBRANCH_PAGE_ALLERGIE = "allergies"

export const modalNames = {
    RPM_APPOINTMENT_HISTORY_MODAL: "rpmAppointmentHistoryModal"
}

export const userStatusArray = ["Active", "Paused", "Cancelled"]
const lorem = ` Lorem ipsum dolor sit amet, consectetur adipiscing elit,
sed do eiusmod tempor incididunt ut labore et dolore magna
aliqua. Ut enim ad minim veniam, quis nostrud exercitation
ullamco laboris nisi ut aliquip ex ea commodo consequat.
Duis aute irure dolor in reprehenderit in voluptate velit esse
cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat
cupidatat non proident, sunt in culpa qui officia deserunt mollit
anim id est laborum.`
export const PRODUCT_LIST = [

    {
        image: AssetStore.care,
        caption: AssetStore.care_caption,
        caption_text: "Augmentedreality",
        dsc: lorem,
        url: "care"

    },
    {
        image: AssetStore.oniniroom,
        caption: AssetStore.ominiroom_caption,
        caption_text: "Omnirom",
        dsc: lorem,
        url: "ominirom"

    },
    {
        image: AssetStore.homedoc,
        caption: AssetStore.homedoc_caption,
        caption_text: "Homedoc",
        dsc: lorem,
        url: "homedoc"

    },
    {
        image: AssetStore.videocall,
        caption: AssetStore.videocall_caption,
        caption_text: "Videocalling",
        dsc: lorem,
        url: "videcall"

    },
    {
        image: AssetStore.rpm,
        caption: AssetStore.rpm_caption,
        caption_text: "Remote Patient Monitoring",
        dsc: lorem,
        url: "rpm"

    }
]
export const THEMES_LIST = ["English", "Arabic"]
